import { render, staticRenderFns } from "./OnboardingSlideshow.vue?vue&type=template&id=4350c372&scoped=true&"
import script from "./OnboardingSlideshow.vue?vue&type=script&lang=js&"
export * from "./OnboardingSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSlideshow.vue?vue&type=style&index=0&id=4350c372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350c372",
  null
  
)

export default component.exports